import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  rejectRecruitmentRequirementStart,
  rejectRecruitmentRequirementSuccess,
  rejectRecruitmentRequirementFailed,
} from "../redux/rejectRecruitmentRequirement";

import { rejectRecruitmentRequirementApi } from "core/http/service/recruitment";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  getListRecruitmentRequirementStart,
  resetListRecruitmentRequirement,
} from "../redux/getListRecruitmentRequirement";
import { toast } from "react-toastify";

function* rejectRecruitmentRequirementWork(
  action: ReturnType<typeof rejectRecruitmentRequirementStart>
) {
  try {
    const res = yield call(rejectRecruitmentRequirementApi, action.payload);
    yield put({
      type: rejectRecruitmentRequirementSuccess.type,
      payload: {
        data: res.data,
      },
    });
    yield put({
      type: resetListRecruitmentRequirement.type,
    });
    yield put({
      type: resetControlPage.type,
      payload: "recruitmentRequirement",
    });
    yield put({
      type: getListRecruitmentRequirementStart.type,
    });
    toast.success("Từ chối yêu cầu tuyển dụng thành công!");
  } catch (error: any) {
    yield put({
      type: rejectRecruitmentRequirementFailed.type,
    });
  }
}

function* watchRejectRecruitmentRequirement() {
  yield takeLatest(
    rejectRecruitmentRequirementStart.type,
    rejectRecruitmentRequirementWork
  );
}

export default function* rejectRecruitmentRequirementSaga() {
  yield all([watchRejectRecruitmentRequirement()]);
}
